/**
 * Centralized API Configuration
 * This file manages all API-related configuration including base URLs, endpoints, and environment settings.
 */

export interface ApiConfig {
  baseURL: string;
  timeout: number;
  endpoints: {
    auth: {
      login: string;
      refresh: string;
      logout: string;
    };
    admin: {
      dashboard: string;
      analytics: {
        growth: string;
        platform: string;
        pets: string;
        messaging: string;
        engagement: string;
        adoptionHistory: string;
      };
      users: string;
      lostPets: string;
      system: {
        health: string;
      };
    };
  };
}

/**
 * Get API configuration based on environment
 */
export const getApiConfig = (): ApiConfig => {
  // const baseURL = process.env.REACT_APP_API_URL || "http://localhost:3000/api";
  const baseURL = process.env.REACT_APP_API_URL || "https://patigo-api.ey.r.appspot.com/api";

  
  return {
    baseURL,
    timeout: 10000,
    endpoints: {
      auth: {
        login: "/auth/login",
        refresh: "/auth/refresh",
        logout: "/auth/logout",
      },
      admin: {
        dashboard: "/admin/dashboard/stats",
        analytics: {
          growth: "/admin/analytics/growth",
          platform: "/admin/analytics/platform",
          pets: "/admin/analytics/pets",
          messaging: "/admin/analytics/messaging",
          engagement: "/admin/analytics/engagement",
          adoptionHistory: "/admin/analytics/adoption-history",
        },
        users: "/admin/users",
        lostPets: "/lost-pets",
        system: {
          health: "/admin/system/health",
        },
      },
    },
  };
};

/**
 * Get full URL for an endpoint
 */
export const getApiUrl = (endpoint: string): string => {
  const config = getApiConfig();
  return `${config.baseURL}${endpoint}`;
};

/**
 * Environment-specific configurations
 */
export const ENV_CONFIG = {
  development: {
    apiUrl: "https://patigo-api.ey.r.appspot.com/api",
    timeout: 10000,
  },
  production: {
    apiUrl: process.env.REACT_APP_API_URL || "https://patigo-api.ey.r.appspot.com/api",
    timeout: 15000,
  },
  staging: {
    apiUrl: process.env.REACT_APP_API_URL || "https://patigo-api.ey.r.appspot.com/api",
    timeout: 12000,
  },
} as const;

/**
 * Get current environment configuration
 */
export const getCurrentEnvConfig = () => {
  const env = process.env.NODE_ENV as keyof typeof ENV_CONFIG;
  return ENV_CONFIG[env] || ENV_CONFIG.development;
};
